"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=BaseProvider.js.map